import React, { useState } from 'react'
import { Box, makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Noa from './noa'
import Armando from './armando'
import About from './about'
import isMobile from './utils/is-mobile'

const useStyles = isMobile()
  ? makeStyles({
      topBar: {
        fontSize: 30,
        textAlign: 'center',
        paddingTop: 10
      },
      mainTitle: {
        fontSize: 40
      },
      unselectedName: {
        display: 'inline-block',
        paddingLeft: 20,
        fontWeight: 300,
        cursor: 'pointer',
        fontSize: 20
      },
      selectedName: {
        display: 'inline-block',
        paddingLeft: 20,
        fontWeight: 500,
        fontSize: 20
      },
      descriptionParagraph: {
        fontFamily: 'Lato',
        fontSize: 18,
        fontWeight: 200,
        width: '90%',
        alignSelf: 'center',
        display: 'inline-block',
        padding: 10,
        whiteSpace: 'pre-line'
      },
      languageBar: {
        textAlign: 'center',
        paddingTop: 2
      },
      languageItem: {
        textDecoration: 'underline',
        margin: 10,
        cursor: 'pointer',
        display: 'inline-block'
      },
      nameContainer: {
        paddingBottom: 10
      }
    })
  : makeStyles({
      topBar: {
        fontSize: 30,
        textAlign: 'center',
        paddingTop: 20
      },
      mainTitle: {
        fontSize: 40
      },
      unselectedName: {
        display: 'inline-block',
        paddingLeft: 20,
        fontWeight: 300,
        cursor: 'pointer',
        borderBottom: '1px solid rgba(0, 0, 0, 0.3)'
      },
      selectedName: {
        display: 'inline-block',
        paddingLeft: 20,
        fontWeight: 500,
        borderBottom: '1px solid rgba(0, 0, 0, 0.3)'
      },
      descriptionParagraph: {
        fontFamily: 'Lato',
        fontSize: 17,
        fontWeight: 200,
        width: '80%',
        alignSelf: 'center',
        display: 'inline-block',
        padding: 35,
        whiteSpace: 'pre-line'
      },
      languageBar: {
        position: 'absolute',
        top: 10,
        right: 0,
        width: 100,
        height: 100,
        display: 'flex',
        flexDirection: 'row'
      },
      languageItem: {
        textDecoration: 'underline',
        margin: 10,
        cursor: 'pointer'
      },
      nameContainer: {
        paddingBottom: 10
      }
    })

const names = ['Noa Geras', 'González Sosto/León']

const App: React.FC = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const [selectedName, setSelectedName] = useState('Noa Geras')

  const handleNameSelect = (event: React.SyntheticEvent) => {
    setSelectedName(event.currentTarget.textContent as string)
  }

  const handleLangSelect = (event: React.SyntheticEvent) => {
    i18n.changeLanguage(event.currentTarget.textContent as string)
  }

  return (
    <>
      <Box className={classes.languageBar}>
        <Box className={classes.languageItem} onClick={handleLangSelect}>
          hr
        </Box>
        <Box className={classes.languageItem} onClick={handleLangSelect}>
          en
        </Box>
      </Box>
      <Box className={classes.topBar}>
        <Box className={classes.mainTitle}>{t('nameOfExhibition')}</Box>
        <Box className={classes.descriptionParagraph}>
          {t('descriptionExhibition')}
        </Box>
        <Box className={classes.nameContainer}>
          {names.map(item => {
            return (
              <Box
                key={item}
                className={
                  item === selectedName
                    ? classes.selectedName
                    : classes.unselectedName
                }
                onClick={handleNameSelect}
              >
                {item}
              </Box>
            )
          })}
        </Box>
      </Box>
      {selectedName === 'Noa Geras' ? <Noa /> : <Armando />}
      <About />
    </>
  )
}

export default App
